import type { IconSvgObject } from './types';

const ChevronLastIcon: IconSvgObject = [
  ["path", { d: "M17 6V18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7.00005 18C7.00005 18 13 13.5811 13 12C13 10.4188 7 6 7 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ChevronLastIcon;
